import { Type } from "@angular/core"
import { GamerecordListItemComponent } from "../gamerecord-list-item/gamerecord-list-item.component"
import { GenericListItemComponent } from "../generic-list-item/generic-list-item.component"
import { PoiListItemComponent } from "../poi-list-item/poi-list-item.component"
import { GamerecordListItemDisabledComponent } from "../gamerecord-list-item-disabled/gamerecord-list-item-disabled.component"
import { GenericListItemDisabledComponent } from "../generic-list-item-disabled/generic-list-item-disabled.component"

export abstract class ListItem {

    abstract className: string
    
    listeners: Set<any> = new Set()
    abstract layoutComponentRef: Type<any>
    // abstract entryComponentRef: Type<any>|undefined

    addListener(obj: any) {
        this.listeners.add(obj)
    }

    removeListener(obj: any) {
        this.listeners.delete(obj)
    }
    
    constructor(
        public title: string,
        public name: string,
        public data: any,
    ) {}

    abstract onClick() 
    abstract onDelete()
    abstract searchFilter(str: string): boolean
    
}

export class ListItemListener {
    onClick: ((item: ListItem) => void)|undefined = undefined
    onDelete: ((item: ListItem)=> void)|undefined = undefined 
}

export class GenericListItem extends ListItem {

    public static className = "GenericListItem"
    public className = "GenericListItem"

    layoutComponentRef = GenericListItemComponent
    public displayDelete = false

    constructor(
        title: string,
        name: string,
        data: any,
        public subTitle?: string|undefined,
        public chipLabel?: string|undefined
    ) {
        super(title, name, data)
    }

    onDelete() {
        this.listeners.forEach((obj: any) => {
            obj.onDelete(this)
        })
    }

    onClick() {
        this.listeners.forEach((obj: any) => {
            obj.onClick(this)
        })
    }

    searchFilter(str: string): boolean {
        return this.data.searchFilter(str)
    }

}

export class GenericListItemDisabled extends ListItem {

    public static className = "GenericListItemDisabled"
    public className = "GenericListItemDisabled"

    layoutComponentRef = GenericListItemDisabledComponent
    public displayDelete = false

    constructor(
        title: string,
        name: string, 
        data: any,
        public subTitle?: string|undefined
    ) {
        super(title, name, data)
    }

    onDelete() { }

    onClick() { }

    searchFilter(str: string): boolean {
        return this.data.searchFilter(str)
    }

}

export class GameRecordListItem extends ListItem {

    public static className = "GameRecordListItem"
    public className = "GameRecordListItem"
    
    layoutComponentRef = GamerecordListItemComponent
    public displayDelete = false

    constructor(
        title: string,
        name: string, 
        data: any,
        public iconName?: string
    ) {
        super(title, name, data)
    }

    onDelete() {
        this.listeners.forEach((obj: any) => {
            obj.onDelete(this)
        })
    }

    onClick() {
        this.listeners.forEach((obj: any) => {
            obj.onClick(this)
        })
    }

    searchFilter(str: string): boolean {
        return this.data.searchFilter(str)
    }

}

export class GameRecordListItemDisabled extends ListItem {

    public static className = "GameRecordListItemDisabled"
    public className = "GameRecordListItemDisabled"
    
    layoutComponentRef = GamerecordListItemDisabledComponent
    public displayDelete = false

    constructor(
        title: string,
        name: string, 
        data: any,
        public iconName?: string
    ) {
        super(title, name, data)
    }

    onDelete() {
        // this.listeners.forEach((obj: any) => {
        //     obj.onDelete(this)
        // })
    }

    onClick() {
        // this.listeners.forEach((obj: any) => {
        //     obj.onClick(this)
        // })
    }

    searchFilter(str: string): boolean {
        return this.data.searchFilter(str)
    }

}

export class SelectableListItem extends ListItem {

    public static className = "SelectableListItem"
    public className = "SelectableListItem"

    public displayDelete = false
    public displayEditPolygon = false

    constructor(
        title: string,
        name: string, 
        data: any,
        public layoutComponentRef: Type<any>,
        public subtitle?: string
    ) {
        super(title, name, data)
    }

    onDelete() {
        this.listeners.forEach((obj: any) => {
            obj.onDelete(this)
        })
    }

    onClick() {
        this.listeners.forEach((obj: any) => {
            obj.onClick(this)
        })
    }

    searchFilter(str: string): boolean {
        return this.data.searchFilter(str)
    }

    onDeleteListItem: ((identifier: string) => void) = null
}

export class PoiListItem extends ListItem{

    public static className = "PoiListItem"
    public className = "PoiListItem"

    layoutComponentRef = PoiListItemComponent
    public displayDelete = false

    constructor(
        title: string,
        name: string, 
        data: any,
        public iconName?: string
    ) {
        super(title, name, data)
    }

    onDelete() {
        this.listeners.forEach((obj: any) => {
            obj.onDelete(this)
        })
    }

    onClick() {
        this.listeners.forEach((obj: any) => {
            obj.onClick(this)
        })
    }

    searchFilter(str: string): boolean {
        return this.data.searchFilter(str)
    }
}